import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
} from '@apollo/client'
import { ApolloProvider as BaseApolloProvider } from '@apollo/client/react'
import { SetContextLink } from '@apollo/client/link/context'
import { type ReactNode, useContext, useMemo } from 'react'
import { AuthContext, type IAuthContext } from 'react-oauth2-code-pkce'

interface Props {
  children: ReactNode
}

export const ApolloProvider = ({ children }: Props) => {
  const { token } = useContext<IAuthContext>(AuthContext)

  const httpLink = useMemo(() => new HttpLink({ uri: import.meta.env.VITE_MYSTRO_GRAPHQL_ENDPOINT }), [])

  const authLink = useMemo(() => {
    return new SetContextLink(({ headers }, _) => {
      return {
        headers: {
          ...headers,
          authorization: token ? `Bearer ${token}` : '',
        },
      }
    })
  }, [token])

  const client = useMemo(() => new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache,
    defaultOptions: {
      query: { fetchPolicy: 'cache-first', errorPolicy: 'all' },
      watchQuery: { notifyOnNetworkStatusChange: false, errorPolicy: 'all' },
      mutate: { errorPolicy: 'all' },
    }
  }), [authLink, httpLink])

  return (
    <BaseApolloProvider client={ client }>
      { children }
    </BaseApolloProvider>
  )
}
